import { useEffect } from 'react';

export default function useScrollToTop() {
    useEffect(() => {
        scroll();
    }, []);

    function scroll() {
        document.body.scrollTo(0, 0);
    }
}
